import { ISagaModule } from "redux-dynamic-modules-saga";
import { rootPortfoliosSaga } from "./sagas";
import { portfoliosReducer } from "./slice";
import { PortfoliosRootState } from "./types";

export const getPortfoliosModule = (): ISagaModule<PortfoliosRootState> => ({
    id: "PortfoliosModule",
    reducerMap: {
        portfolios: portfoliosReducer,
    },
    sagas: [rootPortfoliosSaga],
});
